import { useEffect } from 'react';
import filesToStudies from '../routes/Local/filesToStudies';
import { extensionManager } from '../App';
import { DicomMetadataStore } from '@ohif/core';
import { useNavigate } from 'react-router';

export default function useSttDicomHub(config: AppTypes.Config) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!config.shouldHookSttDicomHub) return;
    console.log(`Hooking into STT Dicom Hub broadcasts`);

    const channel = new BroadcastChannel('dicom-files');
    channel.postMessage({ method: 'ready', body: null });

    const microscopyExtensionLoaded = extensionManager['registeredExtensionIds'].includes(
      '@ohif/extension-dicom-microscopy'
    );

    async function processFiles(files: ArrayBuffer[]) {
      try {
        /**
         * TODO: Create own loader for STTDicomHub dicom data
         *
         * See {@link filesToStudies} */
        const studies = await filesToStudies(files.map(data => new File([data], '')));

        let modePath = 'viewer';

        const query = new URLSearchParams();

        if (microscopyExtensionLoaded) {
          // TODO: for microscopy, we are forcing microscopy mode, which is not ideal.
          //     we should make the local drag and drop navigate to the worklist and
          //     there user can select microscopy mode
          const smStudies = studies.filter(id => {
            const study = DicomMetadataStore.getStudy(id);
            return (
              study.series.findIndex(
                s => s.Modality === 'SM' || s.instances[0].Modality === 'SM'
              ) >= 0
            );
          });

          if (smStudies.length > 0) {
            smStudies.forEach(id => query.append('StudyInstanceUIDs', id));

            modePath = 'microscopy';
          }
        }

        // Todo: navigate to work list and let user select a mode
        studies.forEach(id => query.append('StudyInstanceUIDs', id));
        query.append('datasources', 'dicomlocal');

        navigate(`/${modePath}?${decodeURIComponent(query.toString())}`);
      } catch (e) {
        console.log(e);
      }
    }

    channel.addEventListener('message', async event => {
      const { method, body } = event.data as { method: string; body: any };

      console.log(`[OHIF-Hook]: Received <${method}> message from broadcasting ipc-hook`);

      switch (method) {
        case 'ipc':
          await processFiles(body);
          break;

        case 'fetch':
          const filepaths = body as string[];
          const URLs = filepaths.map(path => new URL(`ohif://dicom/${path}`));

          const responses = await Promise.all(URLs.map(url => fetch(url)));

          const files = await Promise.all(
            responses.map(async response => (await response.bytes()).buffer)
          );

          processFiles(files);
          break;
      }
    });

    return () => {
      channel.close();
    };
  }, [config.shouldHookSttDicomHub]);
}
